import { useNavigate } from 'components/lib';
import Style from './table.tailwind.js';
import { UMButton } from '@urbanmetrix/um-kit';

interface TableRowAction {
  icon?: string;
  color?: string;
  title?: string;
  goto: string;
  condition?: { col: string; value: unknown };
  action: (row: TableRowData) => void;
}

export interface TableRowData {
  id: string | number;
  email?: string;
  actions: {
    custom?: TableRowAction[];
    edit: (row: TableRowData, callback: (res: unknown) => void) => void;
    download: string;
    view: { url: string; col: string };
    email?: boolean;
    invite: (row: TableRowData) => void;
    delete: (row: TableRowData, callback: (res: unknown) => void) => void;
  };
  [key: string]: unknown;
}

export interface TableActionsCallback {
  edit: (res: unknown, row: TableRowData) => void;
  delete: (res: unknown, row: TableRowData) => void;
}

interface TableActionsProps {
  row: TableRowData;
  index: number;
  callback: TableActionsCallback;
}

export default function TableActions(props: TableActionsProps) {
  const row = props.row;
  const navigate = useNavigate();

  return (
    <td key={props.index} className={Style.actions}>
      {row.actions?.custom?.map((action, i) => {
        if (action.condition) {
          return row[action.condition.col] === action.condition.value ? (
            <UMButton key={i} icon={action.icon} onClick={() => action.action(row)} className={Style.actionButton} />
          ) : (
            false
          );
        }
        // console.log('row ', row);
        return (
          // this was updated by Huseyin
          action.goto ? (
            <UMButton
              key={i}
              icon={action.icon}
              color={action.color}
              title={action.title}
              className={Style.actionButton}
              onClick={() => navigate(action.goto + row.id)}
            />
          ) : (
            <UMButton
              key={i}
              icon={action.icon}
              color={action.color}
              title={action.title}
              onClick={() => action.action(row)}
              className={Style.actionButton}
              // goto={action.goto + row.id}
            />
          )
        );
      })}

      {row.actions.edit && (
        <UMButton
          icon="edit"
          color="#16a34a"
          title="Edit"
          onClick={() => row.actions.edit(row, (res) => props.callback.edit(res, row))}
          className={Style.actionButton}
        />
      )}

      {row.actions.download && (
        <UMButton
          icon="download"
          onClick={() => (window.location.href = row.actions.download)}
          className={Style.actionButton}
        />
      )}

      {row.actions.view && (
        <UMButton
          icon="eye"
          onClick={() => navigate(`${row.actions.view.url}/${row[row.actions.view.col]}`)}
          className={Style.actionButton}
        />
      )}

      {row.actions.email && (
        <UMButton
          icon="mail"
          onClick={() => (window.location.href = `mailto:${row.email}`)}
          className={Style.actionButton}
        />
      )}

      {row.actions.invite && (
        <UMButton icon="mail" onClick={() => row.actions.invite(row)} className={Style.actionButton} />
      )}

      {row.actions.delete && (
        <UMButton
          icon="trash"
          color="#e11d48"
          title="Delete"
          onClick={() => row.actions.delete(row, (res) => props.callback.delete(res, row))}
          className={Style.actionButton}
        />
      )}
    </td>
  );
}
